import type { ComponentType } from "react";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { BadmintonMarkIcon } from "@bw/material";
import { resolvePlayerRoute } from "../routeMetadata";
import type { PrimaryJourney } from "../routeMetadata.types";

/**
 * A primary navigation journey. The 5 journeys are the player app's top-level
 * destinations, shared by the responsive drawer/rail and bottom navigation.
 *
 * `icon` renders a decorative MUI icon. A journey's identity is carried by its
 * accessible label (Home/Play/…), not the icon.
 */
export type Journey = {
  id: string;
  label: string;
  to: string;
  icon: ComponentType<SvgIconProps>;
};

export const JOURNEYS: Journey[] = [
  { id: "home", label: "Home", to: "/", icon: HomeRoundedIcon },
  {
    id: "play",
    label: "Play",
    to: "/play",
    icon: BadmintonMarkIcon,
  },
  {
    id: "compete",
    label: "Compete",
    to: "/compete/tournaments",
    icon: EmojiEventsRoundedIcon,
  },
  {
    id: "social",
    label: "Community",
    to: "/community",
    icon: GroupsRoundedIcon,
  },
  { id: "me", label: "Me", to: "/me", icon: PersonRoundedIcon },
];

export function activeJourneyId(pathname: string): PrimaryJourney | null {
  return resolvePlayerRoute(pathname)?.primaryJourney ?? null;
}
